module.exports = __webpack_public_path__ + "img/nb-3.2ba7c48f.png";